import { connect } from 'react-redux';
import Privacy from './privacy';

const mapStateToProps = (state) => ({
  loginType: state.User.loginType,
});

export default connect(mapStateToProps)(Privacy);
